import { Flex, Link } from "@chakra-ui/react";
import {
  ContactUsCard,
  CreateEventCard,
  ShareEventCard,
} from "../CheckoutSuccessCTA/CheckoutSuccessCTACards";
import CheckoutSuccessContainer from "../CheckoutSuccessContainer/CheckoutSuccessContainer";
import CheckoutSuccessHeadings from "../CheckoutSuccessHeadings/CheckoutSuccessHeadings";
import { CheckoutSuccessContentProps } from "../types";

const HOST = process.env.NEXT_PUBLIC_HOST || "https://app.moongate.id";

const CheckoutSuccessMembership = ({
  event,
  tier,
  info,
  itemsCount,
  itemsCurrency,
  itemsFinalAmount,
  language,
  basePath,
}: CheckoutSuccessContentProps) => {
  return (
    <>
      <CheckoutSuccessContainer>
        <CheckoutSuccessHeadings
          heading="Purchase Confirmed!"
          eventType={event.type}
        />

        <Flex
          width="full"
          direction={{ base: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          gap={4}
        >
          <ShareEventCard
            eventType={event.type}
            language={language}
            url={event.toURL(HOST, basePath)}
          />
          <CreateEventCard language={language} type={event.type} />
          <ContactUsCard language={language} />
        </Flex>
        <Link href={event.toURL(HOST, basePath)}>Back to Home</Link>
      </CheckoutSuccessContainer>
    </>
  );
};

export default CheckoutSuccessMembership;
